import { DatabaseChangeType } from '@databases/types/redux';

export const yjsHandlerIgnoreMap = new Set<DatabaseChangeType>([
  // unused
  DatabaseChangeType.UPDATE_FIELD,
  // not possible
  DatabaseChangeType.RESET_FIELD,
  DatabaseChangeType.RESET_FIELD_NAME,
  DatabaseChangeType.UNDELETE_FIELD,
  DatabaseChangeType.RESET_VALUE,
  DatabaseChangeType.UNDELETE_ENTRY
]);
